export default __webpack_public_path__ + "static/media/horizon.56355ff6.jpg";